import { css } from 'twin.macro';
import { Button, FormLabel, InputGroup, Nav } from 'react-bootstrap';
import React, { useState } from 'react';
import { getChannelIdFromSettingsURL } from '../../../../../_helpers';
import { connect } from 'react-redux';

//assets
import ChannelSelectFilter from '../../../../Admin/ChannelSelectFilter';
import { Link } from 'react-router-dom';
import SubmissionTable from './SubmissionTable';
import FormGroupTable from './FormGroupTable';

const TeamSettingsFormGroup = ({ search, teamRooms }) => {
    const channelIdFromUrl = getChannelIdFromSettingsURL();
    const [channel, setChannel] = useState(null);
    const [showSubmission, setShowSubmission] = useState(false);

    const handleChangeChannel = (value) => {
        setChannel(value);
    };

    return (
        <div>
            <div
                css={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;
                `}
            >
                <div
                    css={css`
                        width: 264px;
                        z-index: 3;
                    `}
                >
                    <InputGroup className="flex-column">
                        <FormLabel className="mr-2 ">Channel: </FormLabel>
                        <ChannelSelectFilter
                            assignedChannel={channelIdFromUrl}
                            selectedRoomOption={channel}
                            onRoomSelect={handleChangeChannel}
                            disabled={!!channelIdFromUrl}
                            placeholder="Enter Channel Name"
                            className="bolder"
                            css={css`
                                width: 264px;
                            `}
                        />
                    </InputGroup>
                </div>
                {/* <div> */}
                <div
                    css={css`
                        display: flex;
                        flex-direction: row;
                        gap: 4px;
                    `}
                >
                    <Nav
                        variant="pills"
                        className="pl-2 py-1"
                        css={css`
                            background: #e1e1e1;
                            border-radius: 5px;
                            width: 17rem;
                        `}
                    >
                        <Nav.Item className="ml-1">
                            <Nav.Link
                                as={Button}
                                variant={!showSubmission ? 'primary' : 'link'}
                                onClick={() => setShowSubmission(false)}
                                style={{ fontSize: '1.6rem' }}
                                className={!showSubmission ? 'bg-primary text-white m-1 px-2 py-1' : 'm-1 px-2 py-1'}
                            >
                                Form
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item className="ml-1">
                            <Nav.Link
                                as={Button}
                                variant={showSubmission ? 'primary' : 'link'}
                                onClick={() => setShowSubmission(true)}
                                style={{ fontSize: '1.6rem' }}
                                className={showSubmission ? 'bg-primary text-white m-1 px-2 py-1' : 'm-1 px-2 py-1'}
                            >
                                Submission
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Link
                        to={'/form-group-builder/'}
                        css={css`
                            color: white;
                            text-decoration: none;
                            a:hover {
                                color: white;
                                text-decoration: none;
                            }
                        `}
                    >
                        <Button variant="primary" className="btn px-4 py-3 ">
                            <h4
                                className="mb-0"
                                css={css`
                                    width: 12rem;
                                `}
                            >
                                Build Form Group
                            </h4>
                        </Button>
                    </Link>
                </div>
            </div>

            {showSubmission ? <SubmissionTable channel={channel} /> : <FormGroupTable channel={channel} />}
        </div>
    );
};
const mapStateToProps = (state) => ({
    teamRooms: state.rooms.teamRooms,
});

export default connect(mapStateToProps, {})(TeamSettingsFormGroup);
